import { api } from 'shared/api';
import { setAccountTitle } from 'shared/config/store/reducers/accountsSlice';
import { EMI } from 'shared/model/types';
import { ApiResponse } from 'shared/model/types';
import { Account } from 'entities/account/model/types';

const accountApi = api.injectEndpoints({
  endpoints: (build) => ({
    changeAccountTitle: build.mutation<
      ApiResponse<Account>,
      {
        accountId: number;
        title: string;
      }
    >({
      query: ({ accountId, title }) => ({
        url: `private/river/${accountId}/update-account-title`,
        method: 'POST',
        params: { title },
      }),
      async onQueryStarted({ accountId, title }, { dispatch, queryFulfilled }) {
        const { data } = await queryFulfilled;
        if (data.response)
          dispatch(setAccountTitle({ emi: EMI.Wallester, accountId, title }));
      },
    }),
  }),
});

export const { useChangeAccountTitleMutation } = accountApi;

export default accountApi;
